import { MyTableComponent } from "components"
import { Box } from "theme-ui"
import redselect from "./redselect.png"
import selecticon from "./selecticon.png"
import slidersign from "./slidersign.png"
import { useTranslation } from "react-i18next"

export const UserLogSystem = () => {
       // language translator
 const { t } = useTranslation("translation")
 const data = [
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "Muddassar Haseeb",
   infofour: "182.178.155.78",
   infofive: "27.02.2023 15:09:52",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "Muddassar Haseeb",
   infofour: "182.178.155.78",
   infofive: "27.02.2023 15:09:52",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "Muddassar Haseeb",
   infofour: "182.178.155.78",
   infofive: "27.02.2023 15:09:52",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "Muddassar Haseeb",
   infofour: "182.178.155.78",
   infofive: "27.02.2023 15:09:52",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "Muddassar Haseeb",
   infofour: "182.178.155.78",
   infofive: "27.02.2023 15:09:52",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "Muddassar Haseeb",
   infofour: "182.178.155.78",
   infofive: "27.02.2023 15:09:52",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "Muddassar Haseeb",
   infofour: "182.178.155.78",
   infofive: "27.02.2023 15:09:52",
  },
  {
   infoone: redselect,
   infotwo: "27.02.2023 15:09:52",
   infothree: "Muddassar Haseeb",
   infofour: "182.178.155.78",
   infofive: "27.02.2023 15:09:52",
  },
 ]

 const columns = [
  {
   Header: () => (
    <div className="pl-3">
     <span>
      <img src={data[0].infoone} alt="selectedicon" />
     </span>
    </div>
   ),
   accessor: "infoone",
   Cell: ({ row }: any) => (
    <div>
     <span>
      <img src={row.original.infoone} alt="selecticontwo" />
     </span>
    </div>
   ),
  },
  { Header: t("login"), accessor: "infotwo" },
  { Header: t("user"), accessor: "infothree" },
  { Header: "IP Address", accessor: "infofour" },
  { Header: t("activeUntil"), accessor: "infofive" },
 ]

 return (
  <div className="relative h-screen  md:h-screen lg:h-full w-[96%] mx-auto">
   <div className="flex justify-between mx-2 py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">{t("userLogs")}</h1>
    <div className="bg-white h-10 w-10 rounded flex justify-center items-center">
     <img src={slidersign} alt="slidersignimg" />
    </div>
   </div>
   <Box bg="highlight" className="py-2 px-2">
    <Box bg="light_gray" className="flex justify-between py-4 rounded mx-2 px-3 ">
     <div className="flex items-center">
      <div>
       <img className="rotate-[90deg]" src={selecticon} alt="selecticon" />
      </div>
      <h1 className="font-semibold font-sm Jakarta-font">1000 logins</h1>
     </div>

     <div className="custom-checkbox">
      <input type="checkbox" id="updata" />
      <label className="font-semibold font-sm Jakarta-font" htmlFor="updata">
    {t("updateAutomatically")}
      </label>
     </div>
    </Box>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent fullHeight={false} columns={columns} data={data} paginate={true} />
  </div>
 )
}
